import { View } from '../../compiler'

import { colors, typoStyles } from '../../constants'
import { circleRadius, getInitials } from '../../utils'
import MarkdownText from '../MarkdownText'

const INITIALS_ICON_SIZE = 24
const INITIALS_ICON_HALF = INITIALS_ICON_SIZE / 2

const InitialsIcon = ({
  bottom,
  left,
  label,
  tooltipId,
  tooltipContent,
  tooltipPlace = 'top'
}) => {
  return (
    <div
      style={{
        position: 'absolute',
        left,
        bottom,
        transform: `translate(-${INITIALS_ICON_HALF}px, ${INITIALS_ICON_HALF}px)`,
        padding: 2,
        width: INITIALS_ICON_SIZE,
        height: INITIALS_ICON_SIZE,
        backgroundColor: 'white',
        borderRadius: circleRadius(INITIALS_ICON_SIZE)
      }}
      data-tooltip-id={tooltipId}
      data-tooltip-content={tooltipContent ?? label}
      data-tooltip-place={tooltipPlace}
      className='cursor-default'
    >
      <View
        style={{
          width: 20,
          height: 20,
          backgroundColor: colors.brightBlue,
          borderRadius: circleRadius(20),
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <MarkdownText style={typoStyles.SmallWhite}>
          {getInitials(label)}
        </MarkdownText>
      </View>
    </div>
  )
}

export default InitialsIcon
